import { DisabledTag } from '@nile/components';
import { ServiceCatalogItem } from '../../types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import { OFFERING_TYPES } from '@nile/banyan/src/Pages/Constants/offeringType';

function ServiceItemTypeCell({ cell }) {
  const row: ServiceCatalogItem =
    cell?.row?.original?.serviceCatalogItem || cell?.row?.original;

  if (!row?.itemType && !row?.serviceTypeItem?.offeringType) {
    return (
      <DisabledTag>
        <FormattedMessage id="app.noData.message" />
      </DisabledTag>
    );
  }

  const offeringType =
    OFFERING_TYPES[row?.serviceTypeItem?.offeringType || 'PRODUCT'];

  return (
    <div className="fx actr g5">
      <SVGIcon name={offeringType?.icon} size="sm" />
      <span className="ellipsis mcw-25">
        <FormattedMessage id={offeringType?.key} />
      </span>
    </div>
  );
}

export default ServiceItemTypeCell;
